import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./auth/AuthContext";
import { I18nProvider } from "./i18n/I18nContext";
import { ContentTransliterator } from "./i18n/ContentTransliterator";
import { DemoFilterProvider } from "./context/DemoFilterContext";
import { ToastProvider } from "./context/ToastContext";
import { ConfirmHost } from "./components/Confirm";
import ErrorBoundary from "./components/ErrorBoundary";
import "./styles.css";
import "./styles-modern.css";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <I18nProvider>
        <ContentTransliterator />
        <AuthProvider>
          <DemoFilterProvider>
            <ToastProvider>
              <BrowserRouter>
                <App />
                <ConfirmHost />
              </BrowserRouter>
            </ToastProvider>
          </DemoFilterProvider>
        </AuthProvider>
      </I18nProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
